import { createSelector } from '@ngrx/store';

import { Feedback, FeedbackType } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { feedbackAdapter } from './feedback.reducer';

export const getFeedbackState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.feedback,
);

export const { selectAll: getFeedbackAll } = feedbackAdapter.getSelectors(
  getFeedbackState,
);

export const getFeedbackThumbsByJobIdMap = createSelector(
  getFeedbackAll,
  (entities, { jobId }) => (!!entities && !!jobId)
    ? new Map<number, Feedback>(entities
        .filter((feedback) => feedback.type === FeedbackType.THUMB && feedback.jobId === jobId)
        .map((feedback) => [feedback.candidateId, feedback]))
    : new Map<number, Feedback>()
);
